(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hub-hotel-entrance"] && !Shopify.designMode) return;
  try {
    (()=>{
 const root=document.querySelector('[data-hotel-premium]'); if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const film=root.querySelector('video'),button=root.querySelector('[data-film-play]');
 film.controls=false;button.hidden=false;
 const sync=()=>{button.textContent=film.ended?button.dataset.replay:film.paused?button.dataset.play:button.dataset.pause;};
 button.addEventListener('click',()=>{if(film.paused){if(film.ended)film.currentTime=0;film.play().catch(()=>{film.controls=true;sync();});}else film.pause();});
 for(const event of ['play','pause','ended'])film.addEventListener(event,sync);
 film.addEventListener('error',()=>{film.controls=true;sync();});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)film.pause();});
 if('IntersectionObserver' in window)new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)film.pause();},{threshold:.05}).observe(film);
 for(const item of document.querySelectorAll('.hrs-coming-item'))if((item.textContent||'').toLowerCase().includes('hotel nutzcracker'))item.remove();
 sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hub-seniors-door"] && !Shopify.designMode) return;
  try {
    (function(){
function init(root){
if(root.dataset.hsReady)return;root.dataset.hsReady='true';
root.addEventListener('toggle',function(){if(root.open){var img=root.querySelector('[data-hs-image]');if(img&&!img.hasAttribute('src'))img.src=img.dataset.hsImage;}});
var form=root.querySelector('.hs-form'),help=root.querySelector('[data-hs-help]'),status=root.querySelector('[data-hs-status]');
form.elements.path.addEventListener('change',function(){help.textContent=help.dataset[this.value];status.textContent='';});
form.addEventListener('reset',function(){help.textContent=help.dataset.family;status.textContent='';});
form.addEventListener('submit',function(e){e.preventDefault();var f=form.elements;
var lines=[form.dataset.hsTitle,f.path.selectedOptions[0].textContent,f.person.value,f.prompt.value,f.notes.value,f.session_date.value,f.helpers.value,f.participants.value,f.audience.value,form.querySelector('.hs-note').textContent];
var url=URL.createObjectURL(new Blob([lines.join('\n\n')],{type:'text/plain;charset=utf-8'})),a=document.createElement('a');a.href=url;a.download='my-story-starter.txt';document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url);},1000);status.textContent=status.dataset.ready;});
}
document.querySelectorAll('.hub-seniors-door').forEach(init);
document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('.hub-seniors-door').forEach(init);});
})();
  } catch(e) { console.error(e); }
})();

})();
